module.exports = __webpack_public_path__ + "media/src/img/favicon16-54622f0095f9ff9bfea02092e0740b8e.png";